module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presupuesto-print"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/contenido/banner-print.jpg")
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "davi-curs title-print"
  }, [_vm._v("Presupuesto Mensual")]), _vm._v(" "), _c('div', {
    staticClass: "title-print-two span-red"
  }, [_vm._v("Ingresos")]), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.patrimonioActivo), function(item) {
    return [_c('tr', {
      staticClass: "tr-space"
    }), _vm._v(" "), _vm._l((item.valores), function(itemInt, indexInt) {
      return _c('tr', {
        class: indexInt === 0 ? 'tr-header' : ''
      }, [(indexInt === 0) ? _c('td', {
        attrs: {
          "rowspan": item.valores.length
        }
      }, [_c('div', {
        staticClass: "title-row font-red"
      }, [_c('span', {
        staticClass: "span-red davi-curs"
      }, [_vm._v(_vm._s(item.nombre))])])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-xs-right"
      }, [_c('p', [_vm._v(_vm._s(itemInt.desc))])]), _vm._v(" "), _c('td', {
        staticClass: "input-td"
      }, [_c('div', {
        staticClass: "valor"
      }, [(itemInt.valor) ? [_vm._v(" $" + _vm._s(itemInt.valor) + " ")] : _vm._e(), _vm._v(" "), (!itemInt.valor) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])])
    })]
  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("$" + _vm._s(_vm.patrimonioTotalActivos))])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.patrimonioPasivo), function(item) {
    return [_c('tr', {
      staticClass: "tr-space"
    }), _vm._v(" "), _vm._l((item.valores), function(itemInt, indexInt) {
      return _c('tr', {
        class: indexInt === 0 ? 'tr-header' : ''
      }, [(indexInt === 0) ? _c('td', {
        attrs: {
          "rowspan": item.valores.length
        }
      }, [_c('div', {
        staticClass: "title-row font-red"
      }, [_c('span', {
        staticClass: "span-red davi-curs"
      }, [_vm._v(_vm._s(item.nombre))])])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-xs-right"
      }, [_c('p', [_vm._v(_vm._s(itemInt.desc))])]), _vm._v(" "), _c('td', {
        staticClass: "input-td"
      }, [_c('div', {
        staticClass: "valor"
      }, [(itemInt.valor) ? [_vm._v(" $" + _vm._s(itemInt.valor) + " ")] : _vm._e(), _vm._v(" "), (!itemInt.valor) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])])
    })]
  }), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("$" + _vm._s(_vm.patrimonioTotalActivos))])])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("$" + _vm._s(_vm.patrimonioTotalPasivos))])])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("$" + _vm._s(_vm.diferenciaPatrimonio))])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "form-titles"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Activos")])]), _vm._v(" "), _c('th', {
    staticClass: "font-red davi-curs"
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-xs-right",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Total activo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "form-titles"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Pasivos")])]), _vm._v(" "), _c('th', {
    staticClass: "font-red davi-curs"
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-xs-right font-red davi-curs",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Total activo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-xs-right font-red davi-curs",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Menos (-) Total pasivo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-xs-right",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "davi-curs"
  }, [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v("Patrimonio")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4de74166","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FormCalculadoraPrintPatrimonio.vue
// module id = 970
// module chunks = 1